import CompactSelect from '../../components/common/CompactSelect';
import React, { useState } from 'react';
import { Button, Dialog, DialogActions, DialogContent, DialogTitle } from '@mui/material';
import { useWebLocale } from '../../contexts/WebLocaleContext';
import { albumDefaultSort, albumSorts } from './contracts';
export default function BrowseFilters({ kind, value, onChange }) {
  const { locale } = useWebLocale(),
    en = locale === 'en',
    review = kind === 'reviews';
  const [open, setOpen] = useState(false),
    [draft, setDraft] = useState(value);
  const labels = {
    all: en ? 'All' : '전체',
    korean: en ? 'Korea' : '국내',
    global: en ? 'Global' : '해외',
    albums: en ? 'Albums' : '앨범',
    singles: en ? 'Singles' : '싱글',
    month: en ? 'Month' : '한 달',
    week: en ? 'Week' : '일주일',
    recommended: en ? 'Recommended' : '추천순',
    popular: en ? 'Popular' : '인기순',
    latest: en
      ? review || value.category === 'recommended'
        ? 'Latest'
        : 'Release date'
      : review || value.category === 'recommended'
        ? '최신순'
        : '발매순',
    release: en ? 'Release date' : '발매순',
    reviews: en ? 'Most reviews' : '리뷰순',
    rating: en ? 'Rating' : '평점순',
    likes: en ? 'Most liked' : '좋아요순',
    comments: en ? 'Most comments' : '댓글순',
  };
  const groups = [
    ['region', en ? 'Region' : '국내·해외', ['all', 'korean', 'global'], 'all'],
    ['type', en ? 'Release type' : '유형', ['all', 'albums', 'singles'], review ? 'all' : 'albums'],
    ...(review || value.category === 'releases'
      ? [
          [
            'period',
            en ? 'Period' : '기간',
            review ? ['all', 'month', 'week'] : ['month', 'week'],
            'month',
          ],
        ]
      : []),
    [
      'sort',
      en ? 'Sort' : '정렬',
      review ? ['latest', 'likes', 'comments', 'rating'] : albumSorts(value.category),
      review ? 'latest' : albumDefaultSort(value.category),
    ],
  ];
  return (
    <>
      <div className="pp-browse-filters" aria-label={en ? 'Filters' : '필터'}>
        <button
          type="button"
          className="pp-filter-all"
          aria-label={en ? 'All filters' : '전체 필터'}
          onClick={() => {
            setDraft(value);
            setOpen(true);
          }}
        >
          <svg
            viewBox="0 0 24 24"
            fill="none"
            stroke="currentColor"
            strokeWidth="1.8"
            aria-hidden="true"
          >
            <path d="M4 6h16M7 12h10M10 18h4" />
          </svg>
        </button>
        {groups.map(([id, title, options, defaultValue]) => (
          <CompactSelect
            key={id}
            className={value[id] !== defaultValue ? 'is-changed' : ''}
            label={title}
            value={value[id]}
            onChange={(e) => onChange({ ...value, [id]: e.target.value })}
            options={options.map((option) => [
              option,
              option === 'all' && id === 'region'
                ? en
                  ? 'All regions'
                  : '국내·해외'
                : option === 'all' && id === 'type'
                  ? en
                    ? 'All types'
                    : '유형 전체'
                  : labels[option],
            ])}
          />
        ))}
      </div>
      <Dialog
        open={open}
        onClose={() => setOpen(false)}
        fullWidth
        maxWidth="xs"
        aria-labelledby="browse-filter-title"
      >
        <DialogTitle id="browse-filter-title">{en ? 'Filters' : '전체 필터'}</DialogTitle>
        <DialogContent>
          {groups.map(([id, title, options]) => (
            <fieldset className="pp-filter-options" key={id}>
              <legend>{title}</legend>
              {options.map((option) => (
                <label key={option}>
                  <input
                    type="radio"
                    name={id}
                    value={option}
                    checked={draft[id] === option}
                    onChange={() => setDraft((current) => ({ ...current, [id]: option }))}
                  />
                  {labels[option]}
                </label>
              ))}
            </fieldset>
          ))}
        </DialogContent>
        <DialogActions>
          <Button
            onClick={() =>
              setDraft({
                ...value,
                ...Object.fromEntries(groups.map(([id, , , fallback]) => [id, fallback])),
              })
            }
          >
            {en ? 'Reset' : '초기화'}
          </Button>
          <Button onClick={() => setOpen(false)}>{en ? 'Cancel' : '취소'}</Button>
          <Button
            onClick={() => {
              onChange(draft);
              setOpen(false);
            }}
          >
            {en ? 'Done' : '완료'}
          </Button>
        </DialogActions>
      </Dialog>
    </>
  );
}
